import { debounce, type DebouncedFunc } from "lodash";
import { useEffect, useMemo, useRef } from "react";
import { usePendingSaves } from "./pendingSaves";

export const useDebouncedSave = <Args extends unknown[]>(
  save: (...args: Args) => Promise<void> | void,
  wait = 300,
): DebouncedFunc<(...args: Args) => Promise<void> | void> => {
  const pendingSaves = usePendingSaves();
  const latestSave = useRef(save);
  latestSave.current = save;

  const debounced = useMemo(() => debounce((...args: Args) => latestSave.current(...args), wait), [wait]);

  useEffect(() => {
    pendingSaves?.add(debounced);
    return () => {
      pendingSaves?.delete(debounced);
      debounced.flush();
    };
  }, [debounced, pendingSaves]);

  return debounced;
};
